import { Snackbar, Button, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useCenterNotificationStore } from "../model/store";

import styles from "./CenterNotification.module.scss";

export const CenterNotification = () => {
  const navigate = useNavigate();

  const {
    isOpen,
    message,
    actionLabel,
    actionHref,
    closeCenterAlert,
  } = useCenterNotificationStore();

  const handleActionClick = () => {
    if (actionHref) {
      navigate(actionHref);
    }

    closeCenterAlert();
  };

  return (
    <Snackbar
      open={isOpen}
      onClose={closeCenterAlert}
      autoHideDuration={6000}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <div className={styles.toast}>
        <IconButton
          size="small"
          className={styles.closeBtn}
          onClick={closeCenterAlert}
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        <div className={styles.main}>
          <div className={styles.iconWrap}>
            <CheckIcon className={styles.icon} />
          </div>

          <div className={styles.content}>
            <div className={styles.message}>{message}</div>

            {actionLabel && (
              <div className={styles.footer}>
                <Button
                  variant="contained"
                  onClick={handleActionClick}
                  className={styles.actionBtn}
                >
                  {actionLabel}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </Snackbar>
  );
};